let ajaxUrl = ajax_callback_data.ajax_url;
let checkoutUrl = ajax_callback_data.checkout_url;

document.addEventListener('DOMContentLoaded', function () {
    // Variable product radio button on product detail page
    document.addEventListener('change', function (event) {
        if (event.target.classList.contains('variation-radios') && event.target.tagName === 'INPUT') {
            var checkedInputs = document.querySelectorAll('.variation-radios input:checked');
            checkedInputs.forEach(function (input) {
                var thisName = input.getAttribute('name');
                var thisVal = input.value;
                var selectElement = document.querySelector('select[name="' + thisName + '"]');
                if (selectElement) {
                    selectElement.value = thisVal;
                    selectElement.dispatchEvent(new Event('change'));
                }
            });
        }
    });

    document.addEventListener('woocommerce_update_variation_values', function () {
        var variationInputs = document.querySelectorAll('.variation-radios input');
        variationInputs.forEach(function (input) {
            var thisName = input.getAttribute('name');
            var thisVal = input.value;
            input.removeAttribute('disabled');
            var selectOption = document.querySelector('select[name="' + thisName + '"] option[value="' + thisVal + '"]');
            if (selectOption && selectOption.disabled) {
                input.disabled = true;
            }
        });
    });
});


/***********************************************
 * Disable agree checkbox in checkout page
 **********************************************/
if(document.getElementById('checkbox-agree')) {
    document.getElementById('checkout-agree').prop('disabled', true);
}

jQuery(document).ready(function($) {

    /*********************************************
     * if use have two active subscriptions
     ********************************************/
    $('.full-subscribed').each(function() {
        $(this).on('click', function(e) {
            e.preventDefault();
            let productId = $(this).attr('data-product-id');
            $('.error').remove();
            $('.pricing-plan-wrap-item .plan-card-'+productId).append('<p class="error">You are already on two subscriptions.</p>');
        });
    });

    /**************************
     * add to cart product
     **************************/
    $('.add-to-cart-btn').each(function() {
        $(this).on('click', function(e) {
            e.preventDefault();

            // Get the product ID from the data attribute
            var productId = $(this).data('product-id');

            // Perform AJAX request to add the product to the cart
            var data = {
                action: 'add_to_cart',
                product_id: productId
            };

            $.post(ajaxUrl, data, function(response) {
                // Redirect to checkout page after product is added
                window.location.href = checkoutUrl;
            });
        });
    });

    /*************************************************
     * profile edit change state based on country
     *************************************************/
    $('#account_country').on('change', function() {
        var country = $(this).val();

        // Clear previous states and show loading text
        $('#account_state').html('<option>Loading...</option>');

        // Make AJAX request to get states for the selected country
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'get_states_by_country',
                country: country
            },
            success: function(response) {
                let $html = JSON.parse(response);
                // Populate the state dropdown
                if($html.status) {
                    $('#account_state_text').hide();
                    $('#account_state').show();
                    $('#account_state').html($html.result);
                    $('#account_state_type').val('select');
                } else {
                    $('#account_state').hide();
                    $('#account_state_text').show();
                    $('#account_state_type').val('text');
                }
            }
        });
    });

    /************************************************
     * signup user change state based on country
     ************************************************/
    $('#reg_country').on('change', function() {
        var country = $(this).val();

        // Clear previous states and show loading text
        $('#reg_state').html('<option>Loading...</option>');

        // Make AJAX request to get states for the selected country
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'get_states_by_country',
                country: country
            },
            success: function(response) {
                let $html = JSON.parse(response);
                // Populate the state dropdown
                if($html.status) {
                    $('#reg_state_text').hide();
                    $('#reg_state').show();
                    $('#reg_state').html($html.result);
                    $('#reg_state_type').val('select');
                } else {
                    $('#reg_state').hide();
                    $('#reg_state_text').show();
                    $('#reg_state_type').val('text');
                }
            }
        });
    });

});